import { StyledEngineProvider } from '@mui/material/styles';
import LoadPage from 'components/MainPage/LoadPage';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useStores } from 'store';
import App from './App';
import { Button } from '@ixyberfree/ixybercomponents';

function AppKP() {
    const { AuthStore, ErrorStore } = useStores();

    if (AuthStore.isLoading) {
        return <LoadPage visible={true} />;
    }

    if (ErrorStore.message) {
        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }} /*onClick={() => closeCB && closeCB()}*/
            >
                <div
                    style={{
                        padding: '1em',
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'column'
                    }}
                    onClick={(e) => e.stopPropagation()}>
                    <div style={{ overflow: 'auto' }}>{ErrorStore.message}</div>
                    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '1em' }}>
                        <Button
                            text="OK"
                            size="small"
                            styleType="tinted"
                            onClick={() => {
                                window.location.reload();
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <React.StrictMode>
                <StyledEngineProvider injectFirst>
                    <App />
                </StyledEngineProvider>
            </React.StrictMode>
        );
    }
}

export default observer(AppKP);
